import { COLOR_RED_BASE } from '@alltrails/denali/tokens';
import { createCircleMarker, getCircleMarkerSizeWithoutShadow } from './svgMarkerComponents';

const innerDiameter = 16;
export const svgSizeWithoutShadow = getCircleMarkerSizeWithoutShadow(innerDiameter);
const userPhotoSvg = createCircleMarker({ imageName: 'user-photo', innerDiameter, innerFill: COLOR_RED_BASE });

export default userPhotoSvg;
